export const API_URL = "https://api.kurdgame.net/api/";
export const IMG_URL = "https://api.kurdgame.net/uploads/";
